import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "monitoring",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "teacher-classroom-details" */ "./components"
      ),
      import(
        /* webpackChunkName: "teacher-classroom-details" */ "ClassRoom/modules/ClassRoomModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "classRoom",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [],
});
